import {
  AddOn as AddOnDto,
  HecOverview as HecOverviewDto,
  MalwarebytesOverview as MalwarebytesOverviewDto,
  MalwarebytesProtectionStatus,
  PaginatedResponseHecThreatSummary as HecThreatsDto,
  PaginatedResponseMalwarebytesProtectedDevice as MalwarebytesDevicesDto,
} from '@electricjs/core_entity-client';

export const addOnsList: AddOnDto[] = [
  {
    id: 'add-on-threatdown',
    name: 'ThreatDown',
    vendor: 'Malwarebytes',
    sku: 'threatdown_add_on_placeholder',
  },
  {
    id: 'add-on-email-security',
    name: 'Email Security',
    vendor: 'Avanan',
    sku: 'email_security_add_on_placeholder',
  },
];

export const malwarebytesOverview: MalwarebytesOverviewDto = {
  blocked_threats_count: 100,
  devices_restored_cleaned_count: 2,
  machines_registered_count: 4,
  devices_scanned_count: 4,
};

export const malwarebytesDevices: MalwarebytesDevicesDto = {
  total: 2,
  results: [
    {
      employee_first_name: 'John',
      employee_last_name: 'Doe',
      device_hardware_model: 'MacBook Pro',
      device_serial_number: 'C02XK0ABJGH5',
      device_hostname: 'Johns-MacBook-Pro',
      protection_status: MalwarebytesProtectionStatus.Protected,
      requires_reboot: false,
      group_policy_name: 'Standard',
      last_seen_at: '2021-08-01T12:00:00Z',
      last_scanned_at: '2021-08-01T12:00:00Z',
    },
    {
      employee_first_name: 'Jane',
      employee_last_name: 'Doe',
      device_hardware_model: 'HP Laptop',
      device_serial_number: '5CD1234XYZ',
      device_hostname: 'Janes-HP-Laptop',
      protection_status: MalwarebytesProtectionStatus.Unprotected,
      requires_reboot: true,
      group_policy_name: 'Standard',
      last_seen_at: '2021-08-02T12:00:00Z',
      last_scanned_at: '2021-08-02T12:00:00Z',
    },
  ],
};

export const hecOverview: HecOverviewDto = {
  threats: {
    NEW: {
      total: 124,
      by_category: { SPAM: 51, PHISHING: 23, MALWARE: 14, MALICIOUS_URL: 36 },
      by_severity: { LOW: 10, MEDIUM: 26, HIGH: 23, CRITICAL: 14 },
    },
    REMEDIATED: {
      total: 53,
      by_category: { SPAM: 30, PHISHING: 13, MALICIOUS_URL: 10 },
      by_severity: { LOW: 12, MEDIUM: 20, HIGH: 15, CRITICAL: 6 },
    },
  },
};

export const hecThreats: HecThreatsDto = {
  total: 1,
  results: [
    {
      email: 'john.johnson@electric.ai',
      employee: {
        id: 'a146d50f-6e0f-455c-9e00-b71380d09322',
        first_name: 'John',
        last_name: 'Johnson',
      },
      threats: {
        REMEDIATED: {
          total: 5,
          by_category: { SPAM: 3, PHISHING: 2 },
          by_severity: { LOW: 3, HIGH: 2 },
        },
      },
    },
  ],
};
